<template>
  <div class="container">
    <div>
      <nav-bar title="车辆详情" rightText="首页"></nav-bar>
    </div>
    <!-- 轮播图区 -->
    <div class="swiper" :style="{ height: imgHeight + 'px' }">
      <van-swipe :autoplay="2000" class="my-swiper" @change="onChange">
        <van-swipe-item v-for="(image, index) in detailInfo.pics" :key="index" @click="imagePreview(index)">
          <img v-lazy="image.picUrl" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 基本信息 -->
    <div class="box1">
      <div class="car_name">
        <span>{{ detailInfo.vehicleName }}</span>
      </div>
      <div class="car_text">车辆编号：{{ detailInfo.stockNumber }}</div>
      <div class="car_text">
        <span style="margin-right:5px;" v-if="detailInfo.envLevelText != null && detailInfo.envLevelText">{{ detailInfo.envLevelText }}</span>
        <span>发布日期：{{ detailInfo.publishDate }}</span>
      </div>
      <div class="price">报价：{{ detailInfo.showPrice }}万元</div>
      <div class="frist_price">首付{{ detailInfo.downPayments }}万元把车开回家</div>
      <div class="car_text">
        <span>市场：{{ detailInfo.marketName }}</span>
        <span>店铺:{{ detailInfo.companyName }}</span>
        <span>点击量：{{ detailInfo.hits }}</span>
      </div>
    </div>
    <!-- 直播列表 -->
    <div class="box3" v-if="livePlatformList.length > 0">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="直播列表" name="1">
          <div>
            <van-tag @click="toPlatformNote(item.platformUrl)" size="medium" style="margin:0 5px 5px 0" v-for="(item, index) in livePlatformList" :key="index" round type="primary">{{
              item.platformNote
            }}</van-tag>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <!-- 隔离线 -->
    <div class="line"></div>
    <!-- 基本参数 -->
    <div class="box2">
      <div class="title_box">
        基本参数
      </div>
      <div class="content">
        <div>
          <span>车型：</span>
          <span>{{ detailInfo.vehicleType || '-' }}</span>
        </div>
        <div>
          <span>颜色：</span>
          <span>{{ detailInfo.carColor || '-' }}</span>
        </div>
        <div>
          <span>变速箱：</span>
          <span>{{ detailInfo.gearType }}</span>
        </div>
        <div>
          <span>排量：</span>
          <span>{{ detailInfo.outputVolume || '-' }}{{ detailInfo.outputVolumeU }}</span>
        </div>
      </div>
    </div>

    <!-- 隔离线 -->
    <div class="line" v-if="detailInfo.condDesc"></div>
    <!-- 车辆概述 -->
    <div class="box3" v-if="detailInfo.condDesc">
      <div class="title_box">
        车辆概述
      </div>
      <div class="content">{{ detailInfo.condDesc }}</div>
    </div>

    <!-- 隔离线 -->
    <div class="line"></div>
    <!-- 详细参数 -->
    <div class="box4">
      <div class="title_box" @click="toParams">
        <span>详细参数</span>
        <span>></span>
      </div>
    </div>
    <!-- 隔离线 -->
    <div class="line" v-if="detailInfo.certifyTag == 1"></div>
    <!-- 详细参数 -->
    <div class="box4" v-if="detailInfo.certifyTag == 1">
      <div class="title_box" @click="toReport">
        <span>检测报告</span>
        <span>></span>
      </div>
    </div>
    <!-- 隔离线 -->
    <div class="line"></div>
    <!-- 同车型推荐 -->
    <div class="box5">
      <div class="title_box">
        同车型推荐
      </div>
      <div class="car_list">
        <div class="car_box" v-for="(item, index) in sameModelCarList" :key="index">
          <div class="car_left">
            <img lazy-load :src="item.coverUrl" v-if="item.coverUrl" />
            <img src="../assets/img/default-car.png" alt="" v-else />
          </div>
          <div class="car_right">
            <div class="car_name">
              <span>{{ item.vehicleName }}</span>
            </div>
            <div class="car_info">
              <span> {{ item.registMonth || '未' }}上牌 </span>
              <del>新车价：{{ item.newcarPrice }} 万 </del>
            </div>
            <div class="car_info_price">
              <span>价格：{{ isNumber(item.showPrice) ? item.showPrice + '万' : item.showPrice }}  </span>
            </div>
            <div class="car_info" style="color:#f85d00;">
              <span> 首付{{ item.downPayments }}万元把车开回家</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 隔离线 -->
    <div class="line"></div>
    <!-- 同价位推荐 -->
    <div class="box5">
      <div class="title_box">
        同价位推荐
      </div>
      <div class="car_list">
        <div class="car_box" v-for="(item, index) in samePriceCarList" :key="index">
          <div class="car_left">
            <img lazy-load :src="item.coverUrl" v-if="item.coverUrl" />
            <img src="../assets/img/default-car.png" alt="" v-else />
          </div>
          <div class="car_right">
            <div class="car_name">
              <span>{{ item.vehicleName }}</span>
            </div>
            <div class="car_info">
              <span> {{ item.registMonth || '未' }}上牌 </span>
              <del>新车价：{{ item.newcarPrice }} 万 </del>
            </div>
            <div class="car_info_price">
              <span>价格：{{ isNumber(item.showPrice) ? item.showPrice + '万' : item.showPrice }} </span>
            </div>
            <div class="car_info" style="color:#f85d00;">
              <span> 首付{{ item.downPayments }}万元把车开回家</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 隔离线 -->
    <div class="line"></div>
    <!-- 底部 -->
    <div class="bottom_btn">
      <div class="bottom_btn1">
        <div class="tel1" @click="callPhone"><a href="" ref="tels"></a>电话联系</div>
      </div>
    </div>
    <div style="height:0.45rem;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '车辆详情',
      tradeId: '',
      detailInfo: {},
      //  节约钱
      economyPrice: '',
      current: 0,
      active: 0,
      paramsList: [],
      activeNames: [''],
      kindId: '',
      // 底价
      floorPriceShow: false,
      tel: '',
      telRule: /^1[3456789]\d{9}$/,
      floorPriceConfirmShow: false,
      // 意向价
      notificationShow: false,
      intentionalPrice: '',
      priceRule: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
      notificationConfirmShow: false,

      // 新增
      isShowCheckBtn: false,

      sameModelCarList: [],
      samePriceCarList: [],
      livePlatformList: []
    }
  },
  created() {
    var query = this.$route.query
    if (query.tradeId) {
      this.tradeId = query.tradeId
    }
    var width = window.getComputedStyle(document.getElementById('app')).width
    this.imgHeight = width.substring(0, 3) / 1.5
    window.scrollTo(0, 0)
    this.loadData()
    this.browseCount()

    this.getSameModelCarList()
    this.getSamePriceCarList()

    this.getLivePlatformList()
  },
  methods: {
    isNumber(obj) {
      return typeof obj === 'number' && !isNaN(obj)
    },
    async loadData() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleDetail?tradeId=' + this.tradeId)
      if (data.success) {
        this.detailInfo = data.data.carsInfo
        if (this.detailInfo.kindId) {
          this.kindId = this.detailInfo.kindId
          // this.getParamsList()
        }
        if (this.detailInfo.shelfCode) {
          // this.getCheckReport()
        }
      }
    },
    async browseCount() {
      await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/hits?tradeId=' + this.tradeId)
    },
    async getSameModelCarList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleListByKind?tradeId=' + this.tradeId)
      if (data.success) {
        this.sameModelCarList = data.data.page.rows
      }
    },
    async getSamePriceCarList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleListByPrice?tradeId=' + this.tradeId)
      if (data.success) {
        this.samePriceCarList = data.data.page.rows
      }
    },
    async getLivePlatformList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/livePlatform/list')
      if (data.success) {
        this.livePlatformList = data.data.list
      }
    },
    toParams() {
      this.$router.push({
        path: '/car-params',
        query: {
          tradeId: this.tradeId,
          kindId: this.kindId
        }
      })
    },
    toReport() {
      this.$router.push({
        path: '/check-report',
        query: {
          tradeId: this.tradeId,
          kindId: this.kindId
        }
      })
    },

    onChange(index) {
      this.current = index
    },
    imagePreview(index) {
      var imgs = []
      this.detailInfo.pics.forEach(item => {
        imgs.push(item.picUrl)
      })
      this.$imagePreview({ images: imgs, startPosition: index })
    },

    callPhone() {
      if (this.detailInfo.phone) {
        this.$refs.tels.href = 'tel://' + this.detailInfo.phone
        this.$refs.tels.click()
      } else {
        this.$dialog.alert({
          message: '暂无手机号'
        })
      }
    },
    callPhone1() {
      if (this.detailInfo.userPhone) {
        this.$refs.tels1.href = 'tel://' + this.detailInfo.userPhone
        this.$refs.tels1.click()
      } else {
        this.$dialog.alert({
          message: '暂无手机号'
        })
      }
    },
    // 直播
    toPlatformNote(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="less" scoped>
.van-tabs--line .van-tabs__wrap {
  height: 44px;
  width: 3.75rem;
  margin: 0 auto;
}
.swiper {
  width: 100%;
  .my-swiper {
    height: 100%;
    width: 100%;
    background-color: #ddd;
  }
  .van-swipe-item {
    height: 100%;
    width: 100%;
    .van-swipe__track {
      height: 100%;
      width: 100%;
    }
  }
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.custom-indicator {
  position: absolute;
  z-index: 2;
  bottom: 0;
  width: 100%;
  padding: 2px 16px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #000;
}

.box1 {
  padding: 14px 14px;
  .car_name {
    font-weight: 700;
    line-height: 1.5;
    color: #000;
    font-size: 16px;
  }
  .car_text {
    line-height: 2;
    span {
      margin-right: 10px;
    }
  }
  .price {
    font-size: 18px;
    color: red;
    line-height: 2;
  }
  .frist_price {
    color: #0074f8;
    font-size: 16px;
    line-height: 2;
  }
}

.line {
  background-color: #f2f2f2;
  height: 10px;
}

.title_box {
  height: 35px;
  line-height: 35px;
  border-left: 4px solid #008cd6;
  font-weight: 700;
  padding: 0 10px;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
  justify-content: space-between;
}
.box2 {
  .content {
    display: flex;
    flex-wrap: wrap;
    padding: 5px 14px;
    div {
      width: 50%;
      padding: 5px 0px;
    }
  }
}
.box3 {
  .content {
    padding: 5px 14px;
  }
}
.car_box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 0.9rem;
  padding: 5px;
  .car_left {
    width: 33%;
    height: 100%;
  }
  .car_right {
    width: 62%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .car_name {
      height: 16px;
      font-size: 14px;
      font-weight: 700;
      line-height: 16px;
      white-space: nowrap; /*超出的空白区域不换行*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis;
    }
    .car_info {
      font-size: 14px;
      color: #888;
    }
  }
}
// 底部
.bottom_btn {
  position: fixed;
  bottom: 0;
  width: 3.75rem;
  height: 0.45rem;
  z-index: 999;
  background-color: #fff;
  .bottom_btn1 {
    display: flex;
    width: 3.75rem;
    height: 0.45rem;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    box-sizing: border-box;
    background-color: #008cd6;
    cursor: pointer;
    color: #fff;
  }
}
</style>
